export var getEmptyPlace = function () {
    var resultViewData = {
        id: "",
        name: "",
        description: "",
        isFree: "false",
        isIndoor: "false",
        coverFiles: [],
        sports: [],
        cityId: [],
        cityName: "",
        latitude: NaN,
        longitude: NaN,
    };
    return resultViewData;
};
